import { useState } from "react";
import styled from "styled-components";
import Backdrop from "components/global/Backdrop";
import Button from "components/global/Button";
import ModalWrapper from "components/global/ModalWrapper";
import WarningIconTriangle from "icons/WarningIconTriangle";
import ControlledCheckBox from "components/global/ControlledCheckbox";

const Wrapper = styled(Backdrop)`
  .card {
    background-color: #fff;
    width: 480px;
    border-radius: 16px;
    padding: 48px;
    text-align: center;
  }

  header {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 16px;
    color: var(--text_dark);
  }

  .description {
    font-size: 14px;
    font-weight: 450;
    color: var(--body_text);
    line-height: 1.5;
    margin-bottom: 24px;
  }

  .checkbox-row {
    margin-bottom: 12px;
    text-align: left;

    label {
      font-size: 13px;
      line-height: 1.3;
    }
  }

  .note {
    font-size: 12px;
    font-style: italic;
    color: var(--grey_2);
    margin-top: 8px;
    color: #865503;
    border: 1px solid var(--warning);
    background-color: #fff8e5;
    border-radius: 8px;
  }

  .btn-row {
    margin-top: 24px;
    gap: 24px;

    button {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 768px) {
    .card {
      width: calc(100% - 24px);
      padding: 24px;

      header {
        font-size: 16px;
      }

      .description,
      .note {
        font-size: 14px;
        line-height: 20px;
      }

      .checkbox-row label {
        font-size: 12px;
      }
    }
  }
`;

const InstagramConnectionModal = ({
  showModal,
  onCancel,
  onConnectWithFacebook,
}) => {
  const [isDisconnectConfirmed, setIsDisconnectConfirmed] = useState(false);
  const [isFacebookPageConfirmed, setIsFacebookPageConfirmed] = useState(false);

  const isFullyConfirmed = isDisconnectConfirmed && isFacebookPageConfirmed;

  return (
    <Wrapper className={`flexRow justifyEnd ${showModal && "show"}`}>
      <ModalWrapper>
        <div className="card">
          <header>Instagram Analytics Access</header>

          <div className="description">
            To access Instagram analytics, please connect your Instagram account
            through Facebook.
          </div>

          <div className="checkbox-row">
            <ControlledCheckBox
              id="disconnect-confirm"
              checked={isDisconnectConfirmed}
              onClick={() => setIsDisconnectConfirmed(!isDisconnectConfirmed)}
              label="I understand this will disconnect my current Instagram"
            />
          </div>

          <div className="checkbox-row">
            <ControlledCheckBox
              id="facebook-page-confirm"
              checked={isFacebookPageConfirmed}
              onClick={() =>
                setIsFacebookPageConfirmed(!isFacebookPageConfirmed)
              }
              label="I have a Facebook Page linked to my Instagram account"
            />
          </div>

          <div className="btn-row flexRow alignCenter justifySpaceBetween">
            <Button
              text="Cancel"
              height="48px"
              fullWidth
              className="borderedGrey"
              onClick={onCancel}
            />
            <Button
              text="Connect with Facebook"
              height="48px"
              fullWidth
              bg="var(--secondary)"
              onClick={onConnectWithFacebook}
              disabled={!isFullyConfirmed}
            />
          </div>
        </div>
      </ModalWrapper>
    </Wrapper>
  );
};

export default InstagramConnectionModal;
